import { FC, useMemo, useState } from 'react';
import {
    CalendarBackgroundModal,
    CalendarModalWrapper,
} from '../Calendar/styles';

import { CalendarWithWavesContainer, CustomDropdown } from './styles';

import { addDaysToDate } from '../../helpers/utils';
import { useGetShopItemsPark } from '../../hooks/useGetShopItemsPark';
import {
    CartServiceType,
    CartValuesServiceStore,
    useShoppingCartStore,
} from '../../store/shoppingCart/shoppingCartStore';
import { BigButton } from '../BigButton';
import { CalendarProps } from '../Calendar';
import { CustomReactCalendar } from '../Calendar/CustomReactCalendar';
import { Dropdown } from '../Dropdown';
import { PseudoCalendar } from '../PseudoCalendar';
import animations from '../../helpers/animations';

interface CalendarWithParkProps extends Omit<CalendarProps, 'onClose'> {
    onClose?: (d: CartValuesServiceStore | null) => void;
    defaultData: CartValuesServiceStore;
}

export const CalendarWithPark: FC<CalendarWithParkProps> = ({
    onClose,
    defaultData,
}) => {
    const { cartValues } = useShoppingCartStore();
    const [value, setValue] = useState<Date>(defaultData.date);
    const [currentParkTitle, setCurrentParkTitle] = useState<string>(
        defaultData.title
    );

    const modifyValueInDays = (days: number) => () => {
        setValue(oldValue => {
            const newValue = addDaysToDate(oldValue, days);
            return newValue;
        });
    };

    const { data: dateParks } = useGetShopItemsPark({
        Date: value,
    });

    const parksWithoutCart = useMemo(() => {
        if (!dateParks?.length) return [];

        const dateParksElements = dateParks.filter(service => {
            cartValues?.find(cart => cart.id === String(service.id));

            return !!cartValues;
        });

        return dateParksElements;
    }, [cartValues, dateParks]);

    const findCurrentServiceSelected = useMemo(
        () =>
            parksWithoutCart.find(
                item => item.exhibitionName === currentParkTitle
            ),
        [currentParkTitle, parksWithoutCart]
    );

    const generalData: CartValuesServiceStore = {
        id: String(findCurrentServiceSelected?.id || defaultData.id),
        date: value,
        type: CartServiceType.Park,
        value: findCurrentServiceSelected?.value || defaultData.value,
        title: findCurrentServiceSelected?.exhibitionName || defaultData.title,
    };

    return (
        <CalendarBackgroundModal
            onClick={e => {
                e.stopPropagation();
                onClose && onClose(null);
            }}
            {...animations.calendar}
        >
            <CalendarModalWrapper
                onClick={e => {
                    e.stopPropagation();
                }}
            >
                <CalendarWithWavesContainer>
                    <h2 className="title">Calendário</h2>

                    <div className="category-wrapper">
                        <CustomDropdown>
                            <Dropdown
                                elements={parksWithoutCart.map(item => ({
                                    id: String(item.id),
                                    value: item.exhibitionName,
                                }))}
                                title="Selecione um serviço"
                                setCurrentSelected={setCurrentParkTitle}
                                currentSelected={currentParkTitle}
                                allSize
                            />
                        </CustomDropdown>
                    </div>
                    <PseudoCalendar
                        onNext={modifyValueInDays(1)}
                        onPrevious={modifyValueInDays(-1)}
                        date={value!}
                    />
                    <CustomReactCalendar
                        setValue={setValue}
                        value={value}
                        // pricesProductId={generalData.id}
                        ignoreBasicValidation={true}
                    />
                    <div className="line-divider"></div>
                    <div className="buttons-wrapper">
                        <BigButton
                            color="secondary-alt"
                            bgColor="secondary"
                            children={'Cancelar'}
                            onClick={e => {
                                e.stopPropagation();
                                if (onClose) onClose(null);
                            }}
                        />
                        <BigButton
                            color="primary"
                            bgColor="primary"
                            children={'Salvar'}
                            onClick={e => {
                                e.stopPropagation();
                                if (onClose) onClose(generalData);
                            }}
                        />
                    </div>
                </CalendarWithWavesContainer>
            </CalendarModalWrapper>
        </CalendarBackgroundModal>
    );
};
